import "core-js/modules/es.number.is-finite.js";
import "core-js/modules/es.number.is-integer.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import AreaOutput from './AreaOutput.vue';
import RoomOutput from './RoomOutput.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ApartmentSpaceOutput',
  props: {
    input: null,
    roomType: {
      default: 'long'
    },
    hideRooms: {
      type: Boolean,
      default: false
    },
    empty: {
      default: 'Неизвестно'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var rooms = computed(function () {
      var _props$input;
      return (_props$input = props.input) === null || _props$input === void 0 ? void 0 : _props$input.rooms;
    });
    var area = computed(function () {
      var _props$input2;
      return (_props$input2 = props.input) === null || _props$input2 === void 0 ? void 0 : _props$input2.area;
    });
    var hasRooms = computed(function () {
      return Number.isInteger(rooms.value);
    });
    var hasArea = computed(function () {
      return Number.isFinite(area.value);
    });
    var isEmpty = computed(function () {
      return !hasRooms.value && !hasArea.value;
    });
    var showRooms = computed(function () {
      return !props.hideRooms && hasRooms.value;
    });
    return {
      __sfc: true,
      props: props,
      rooms: rooms,
      area: area,
      hasRooms: hasRooms,
      hasArea: hasArea,
      isEmpty: isEmpty,
      showRooms: showRooms,
      AreaOutput: AreaOutput,
      RoomOutput: RoomOutput
    };
  }
});